module.exports = __webpack_public_path__ + "img/lagerausbildung-en.6672a771.png";